module.exports = __webpack_public_path__ + "img/39.2ecf5e0b.webp";